import React from 'react';
import { styled } from '@linaria/react';

import { MAX_NUM_OF_LIKES } from '@/constants';
import useForceUpdate from '@/hooks/use-force-update';
import useSound from '@/hooks/use-sound';

import LikeButton from '@/components/LikeButton';
import LikeButtonParticles from '@/components/LikeButton/LikeButtonParticles';

function DemoLikeButton() {
  const [playFill] = useSound('/sounds/glug-b.mp3', {
    interrupt: true,
    volume: 0.25,
  });
  const [playPop] = useSound('/sounds/pop.mp3', { volume: 0.5 });

  const forceUpdate = useForceUpdate();
  const [totalNumLikesFromUser, setTotalNumLikesFromUser] =
    React.useState(0);

  return (
    <Wrapper>
      <LikeButtonParticles
        size={48}
        totalNumLikesFromUser={totalNumLikesFromUser}
      />
      <LikeButton
        size={48}
        totalNumLikesFromUser={totalNumLikesFromUser}
        onLike={() => {
          if (totalNumLikesFromUser < MAX_NUM_OF_LIKES) {
            const newNumOfLikes = totalNumLikesFromUser + 1;

            setTotalNumLikesFromUser(newNumOfLikes);

            playFill({
              playbackRate:
                (newNumOfLikes - 1) / (MAX_NUM_OF_LIKES - 1) + 0.9,
            });

            if (newNumOfLikes === MAX_NUM_OF_LIKES) {
              playPop();
            }
          }
        }}
        onMaxLike={forceUpdate}
        onUnlike={() => {
          if (totalNumLikesFromUser > 0) {
            const newNumOfLikes = totalNumLikesFromUser - 1;

            setTotalNumLikesFromUser(newNumOfLikes);

            playFill({
              playbackRate:
                (newNumOfLikes - 1) / (MAX_NUM_OF_LIKES - 1) + 0.9,
            });
          }
        }}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export default React.memo(DemoLikeButton);
